import React from 'react';
import { Container, Row, Col, Card, Button, Navbar, Nav } from 'react-bootstrap';
import FileInputComponent from '../generic/FileInputComponent';
import TranslationNavBarComponent from '../generic/TranslationNavBarComponent';
import './TranslationQuoteScreen.css'

const TranslationQuotePage: React.FC = () => {
    return (
            <div className="d-flex flex-column min-vh-100">
                {/* Header */}
                <TranslationNavBarComponent />

                {/* Main Content */}
                <Container className="flex-grow-1 my-4">
                    <Row>
                        <Col lg={8}>
                            <h1 className="mb-4">Get Your Translation Quote</h1>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Upload Your Content</Card.Title>
                                    <Card.Text>
                                        Choose your input method and provide your content for translation.
                                        We accept text input or file upload (PDF, DOCX, PNG, JPG).
                                    </Card.Text>
                                    <FileInputComponent />
                                    <Button variant="primary" className="mt-3">Get Quote</Button>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={4}>
                            <Card className="mb-4">
                                <Card.Body>
                                    <Card.Title>Why Choose Us?</Card.Title>
                                    <ul className="list-unstyled">
                                        <li>✓ Professional translators</li>
                                        <li>✓ Quick turnaround times</li>
                                        <li>✓ Competitive pricing</li>
                                        <li>✓ 100% satisfaction guarantee</li>
                                    </ul>
                                </Card.Body>
                            </Card>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Need Help?</Card.Title>
                                    <Card.Text>
                                        Our team is here to assist you. Contact us for any questions about our translation services.
                                    </Card.Text>
                                    <Button variant="outline-primary">Contact Support</Button>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>

                {/* Footer */}
                <footer className="bg-dark text-light py-4 mt-auto">
                    <Container>
                        <Row>
                            <Col md={6}>
                                <h5>TranslateNow</h5>
                                <p>Professional translation services for all your needs.</p>
                            </Col>
                            <Col md={3}>
                                <h5>Quick Links</h5>
                                <ul className="list-unstyled">
                                    <li><a href="#" className="text-light">Home</a></li>
                                    <li><a href="#" className="text-light">Services</a></li>
                                    <li><a href="#" className="text-light">About Us</a></li>
                                    <li><a href="#" className="text-light">Contact</a></li>
                                </ul>
                            </Col>
                            <Col md={3}>
                                <h5>Contact Us</h5>
                                <address>
                                    1234 Translation Lane<br />
                                    Linguist City, LC 56789<br />
                                    Email: info@translatenow.com<br />
                                    Phone: (555) 123-4567
                                </address>
                            </Col>
                        </Row>
                        <hr />
                        <p className="text-center mb-0">© 2024 TranslateNow. All rights reserved.</p>
                    </Container>
                </footer>
            </div>
    );
};

export default TranslationQuotePage;